import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SetHook from './router/telegram_hook';
import NginxFileGenerator from './router/nginx';
import App from './App';
import './index.css';
import PasswordGenerator from './router/pass_gen';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/telegram" element={<SetHook />} />
        <Route path="/nginx" element={<NginxFileGenerator />} />
        <Route path="/password" element={<PasswordGenerator />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
